<template>
    <div>
        <div v-if="marcacao && marcacao.estoque_solicitacoes && marcacao.estoque_solicitacoes.length">
            <div class="small">
                <span class="badge badge-secondary mr-2">{{ marcacao.estoque_solicitacoes.length }}</span>
                <a href="#" @click.prevent="exibir_solics = !exibir_solics" class="card-link">{{ $route.meta.vacina ? 'Solicitação de Consumo da Vacina' : 'Solicitações de Mat/Med' }}</a>
            </div>
            <ul class="list-group" v-if="exibir_solics">
                <li class="list-group-item d-flex justify-content-between" v-for="(solic, isx) in marcacao.estoque_solicitacoes" :key="isx">
                    <div>
                        <div>
                            #{{ solic.id_estoque_solicitacao }}
                            <span class="small text-muted ml-2" v-if="solic.local">{{ solic.local.st_estoque_local }}</span>
                        </div>
                        <div v-for="(esi, iex) in solic.items" :key="iex">
                            <i class="fa-solid fa-circle-exclamation text-warning fa-fw mr-2" v-if="esi.links && esi.links.length && !esi.links.find(link => link.movimentacao.in_quantidade)"></i>
                            <i class="fa-solid fa-circle text-secondary fa-fw mr-2" v-else-if="!esi.links || !esi.links.length"></i>
                            <i class="fa-solid fa-circle-check text-success fa-fw mr-2" v-else></i>

                            {{ esi.item.search }}

                            <ul v-if="esi.links && esi.links.length">
                                <li v-for="(link, ilx) in esi.links" :key="ilx" class="small">
                                    {{ link.movimentacao.in_quantidade}}/{{ esi.in_quantidade }}
                                    <span v-if="link.movimentacao.st_lote" class="ml-3">
                                        Lote: {{ link.movimentacao.st_lote }}
                                    </span>
                                    <span>
                                        <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                        {{ $util.getFormatDate(link.movimentacao.dt_movimentacao) }}
                                        {{ link.movimentacao.dt_movimentacao.slice(11,16) }}
                                    </span>
                                    <span v-if="link.movimentacao.st_observacao" class="text-muted">
                                        <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                        {{ link.movimentacao.st_observacao }}
                                    </span>
                                </li>
                            </ul>

                        </div>
                        
                    </div>
                    <template v-if="false">
                        <div v-if="$route.meta.vacina && atendimento.dt_inicio && atendimento.dt_inicio.slice(0,10) == $util.hoje()">
                            <button type="button" class="btn btn-sm btn-outline-danger ml-1" v-if="solic.atendido && solic.items.find(item => item.links.find(link => link.movimentacao.in_quantidade))" @click="cancelar_atendimento_solicitacao_estoque(solic)">
                                Cancelar Atendimento
                            </button>

                            <button type="button" class="btn btn-primary" v-else-if="!solic.atendido" @click="atender_solicitacao_estoque(solic)">
                                Atender
                            </button>

                            <button type="button" class="btn btn-success" v-else-if="!isx" @click="regerar_solic_vacina()">
                                Re-Solicitar
                            </button>
                        </div>
                    </template>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return { 
            exibir_solics: false, 
        }
    },

    props: ['marcacao'], 
}
</script>
